import { Home, Zap, Bot, Coins, BarChart3, Settings } from 'lucide-react';

/** Üst menü: başlıklar → sayfalar. Her sayfa, DashboardSections'taki bölüm anahtarlarını listeler. */
export const NAV_GROUPS = [
    { key: 'home', label: 'Ana Sayfa', icon: Home, path: '/', sections: ['regime', 'home'] },
    {
        key: 'sinyaller', label: 'Sinyaller', icon: Zap,
        items: [
            { path: '/sinyaller', label: 'Bugün ne yapmalı', emoji: '🔥', desc: 'Patlama adayları + sistem önerileri, botun durumuyla', sections: ['regime', 'adaylar'] },
            { path: '/diger-coinler', label: 'Diğer Coinler', emoji: '🧭', desc: 'Aday olmayan coinlerin yön eğilimi', sections: ['digerCoinler'] },
            { path: '/tarayici', label: 'Tüm Fırsatlar — Tarayıcı', emoji: '📊', desc: 'Tüm coinler, puanlar ve tavsiyeler', sections: ['tarayici'] },
            { path: '/uyarilar', label: 'Erken Uyarılar', emoji: '🚨', desc: 'Olağandışı hacim, pump/dump, haber', sections: ['uyarilar'] },
            { path: '/analiz', label: 'Detaylı Analiz', emoji: '🔎', desc: 'Öneri geçmişi, yüksek ihtimal, ilk hareket, radar, tren raporu, güçlü alarm', sections: ['onerilerim', 'firsatlar', 'ilkHareket', 'radar', 'trenRaporu', 'guclu'] },
        ],
    },
    {
        key: 'botlar', label: 'Botlar', icon: Bot,
        items: [
            { path: '/bot', label: 'Otomatik Bot', emoji: '🤖', desc: 'Gerçek ve sanal bot: pozisyonlar, ayarlar, radar', sections: ['autobot'] },
            { path: '/hizli-bot', label: 'Hızlı Kâr Botu', emoji: '⚡', desc: 'Tek slot, küçük kârı hemen al', sections: ['scalper'] },
            { path: '/aralik-bot', label: 'Aralık Botu', emoji: '📐', desc: 'Seçtiğin coinlerde, yazdığın fiyat aralığında kademe kademe al-sat', sections: ['range'] },
        ],
    },
    {
        key: 'coin', label: 'Coin', icon: Coins,
        items: [
            { path: '/coin', label: 'Aktif Coin — Analiz', emoji: '💼', desc: 'Seçili coinin grafiği, pozisyon planı, karar raporu, AI yorumu', sections: ['coin'] },
            { path: '/takibim', label: 'Benim Takibim', emoji: '📌', desc: 'Takibe aldığın öneriler, canlı kâr/zarar', sections: ['takibim'] },
            { path: '/favoriler', label: 'Favorilerim', emoji: '⭐', desc: 'Yıldızladığın coinler canlı', sections: ['favoriler'] },
        ],
    },
    {
        key: 'raporlar', label: 'Raporlar', icon: BarChart3,
        items: [
            { path: '/basari', label: 'Sistem Başarı Oranı', emoji: '🏆', desc: 'Resmi sinyallerin isabeti, sanal defter', sections: ['basari'] },
            { path: '/radar-gecmis', label: 'Radar Sonuç Geçmişi', emoji: '📜', desc: 'Hangi kurulum tutuyor?', sections: ['radarGecmis'] },
            { path: '/ogrenme', label: 'Öğrenme & Gelişim', emoji: '🧠', desc: 'Botun öğrenme seviyesi, trader notu, gelişim planı ve karneler', sections: ['ogrenme'] },
            { path: '/kazanc', label: 'Kazanç Raporu', emoji: '💰', desc: 'Günlük / aylık kazanç — normal, hızlı ve aralık botu, tarih filtresi', sections: ['kazanc'] },
            { path: '/rehber', label: 'Rehber', emoji: '📖', desc: 'Terimler ve işaretler ne demek?', sections: ['legend'] },
        ],
    },
    {
        key: 'ayarlar', label: 'Ayarlar', icon: Settings,
        items: [
            { path: '/telegram', label: 'Telegram Bildirimleri', emoji: '📱', desc: 'Sinyaller ve bot mesajları telefonuna', sections: ['telegram'] },
        ],
    },
];

export const HOME_PAGE = { ...NAV_GROUPS[0], group: NAV_GROUPS[0], emoji: '🏠', desc: 'Özet ve hızlı erişim' };

/** Düz sayfa listesi (ana sayfa dahil). */
export const PAGES = [HOME_PAGE, ...NAV_GROUPS.filter((g) => g.items).flatMap((g) => g.items.map((it) => ({ ...it, group: g })))];

export function pageForPath(pathname) {
    const clean = (pathname || '/').replace(/\/+$/, '') || '/';
    return PAGES.find((p) => p.path === clean) || HOME_PAGE;
}

/** Bir bölüm anahtarını (ör. 'telegram') gösteren sayfanın yolu. */
export function pathForSection(key) {
    if (key === 'bot') return '/bot';
    return (PAGES.find((p) => p.sections.includes(key)) || HOME_PAGE).path;
}
